import { Component, effect, input, OnDestroy } from '@angular/core';
import { EmptyResultPlaceholderOptions } from '@shared/interfaces/dev';

@Component({
  selector: 'idel-empty-result-placeholder',
  templateUrl: './empty-result-placeholder.component.html',
  styleUrl: './empty-result-placeholder.component.scss',
})
export class EmptyResultPlaceholderComponent implements OnDestroy {
  public readonly emptyMessage = input.required<string>();
  public readonly options = input.required<EmptyResultPlaceholderOptions>();
  private readonly optionsEff = effect(() => {
    const { callbackButton, retry } = this.options();

    if (!callbackButton && !retry) {
      throw new Error('Empty message component needs wether `callbackButton` or `retry` option');
    }
  });

  ngOnDestroy(): void {
    this.optionsEff.destroy();
  }

  public reloadPage(): void {
    location.reload();
  }
}
